export type JournalStatus = 'DRAFT' | 'PENDING_APPROVAL' | 'POSTED' | 'VOIDED';

export interface JournalSummary {
  id: string;
  number: string | null;
  date: string;
  source: string;
  status: JournalStatus;
  narration: string;
  reference: string;
  totalDebit: string;
  totalCredit: string;
  rowVersion: number;
  voidReason: string | null;
}

export interface JournalLine {
  id: string;
  lineNo: number;
  accountId: string;
  accountCode: string;
  accountName: string;
  debit: string;
  credit: string;
  description: string;
  dimensions: Record<string, string>;
  dimensionLabels: string[];
}

export interface JournalDetail extends JournalSummary {
  autoReverseDate: string | null;
  period: { id: string; name: string; status: string };
  createdById: string;
  createdBy: string | null;
  postedBy: string | null;
  approvedBy: string | null;
  voidedBy: string | null;
  voidedAt: string | null;
  postedAt: string | null;
  reversalOf: { id: string; number: string | null } | null;
  reversals: { id: string; number: string | null; source: string }[];
  lines: JournalLine[];
}

export const STATUS_TONE = {
  DRAFT: 'neutral',
  PENDING_APPROVAL: 'warning',
  POSTED: 'ok',
  VOIDED: 'critical',
} as const;

export const STATUS_LABEL: Record<JournalStatus, string> = {
  DRAFT: 'Draft',
  PENDING_APPROVAL: 'Awaiting approval',
  POSTED: 'Posted',
  VOIDED: 'Voided',
};

export const SOURCE_LABEL: Record<string, string> = {
  MANUAL: 'Manual',
  OPENING: 'Opening',
  REVERSAL: 'Reversal',
  VOID: 'Void',
  CLOSING: 'Closing',
  SALES: 'Sales',
  RECEIPT: 'Receipt',
  PURCHASE: 'Purchase',
  PAYMENT: 'Payment',
  BANK: 'Bank',
  EVENT: 'Integration',
  TAX: 'Tax',
  INVENTORY: 'Inventory',
};
